import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.scss';
import promoSvg from '../../assets/images/hp/main.svg';
import useApi from "../../hooks/useApi";
import useMedia from "../../hooks/useMedia";


const HomePage = () => {
  const [activeAboutItem, setActiveAboutItem] = useState(`01`);

  const utms = useLocation().search;

  const isTablet = useMedia('isTablet');
  const { data: {item}, isLoading } = useApi({
    payload: ["panpartner:blog.ajax", "getMonthItem"],
  })


  return (
    <>
      <section className="hp__promo">
        <div className="wrapper">
          <object type="image/svg+xml" className="hp__promo-img" data={promoSvg} alt="" />

          <div className="wrapper__center">
            <div className="hp__promo-content" style={isTablet && item ? {height: '600px'} : {}}>
              <span className="hp__label color-red caps">пан партнер</span>
              <h1 className="hp__h1 h1">Экосистема недвижимости</h1>
              <p className="hp__sign color-brand-3 big-text">Готовые решения любых задач — в сфере недвижимости</p>
              <Link to={`/trial${utms}`} className="hp__promo-btn button button_view_default" type="button">Доступ без регистрации</Link>
              {item &&
                <a href={item?.link} target="_blank" className="hp__action" style={{marginTop: 18}}>
                  <ActionIcon/>
                  <p className="hp__action-text">{item?.title}</p>
                </a>
              }
            </div>
          </div>
        </div>
      </section>


      <div className="wrapper">
        <div className="wrapper__center">
          {/*<section className="hp__about hp__section-margin">*/}

          {/*  <div className="hp__title">*/}
          {/*    <h2 className="h2 hp__h2">Платформа для каждого</h2>*/}
          {/*  </div>*/}


          {/*  <div className="hp__about-list">*/}

          {/*    {*/}
          {/*      AboutItems.map(item => (*/}
          {/*        <div*/}
          {/*          className={`hp__about-item${activeAboutItem == item.id ? ` active` : ``}`}*/}
          {/*          onMouseEnter={() => setActiveAboutItem(item.id)}*/}
          {/*          key={`about-${item.id}`}*/}
          {/*        >*/}
          {/*          <h4 className="h5 hp__about-title">{item.title}</h4>*/}
          {/*          <p className="big-text-sm hp__about-descr">{item.descr}</p>*/}
          {/*          <img className="hp__about-img" src={require(`../../assets/images/hp/about/${item.id}.svg`).default} alt="" />*/}
          {/*          <Link to={`${item.link}${utms}`} className="hp__about-btn button button_view_default">{item.isSelf ? `Подробнее` : `Стать партнером`}</Link>*/}
          {/*        </div>*/}
          {/*      ))*/}
          {/*    }*/}
          {/*    </div>*/}

          {/*  </section>*/}

          <section className="hp__develop hp__section-margin">

          <div className="hp__title">
            <h2 className="h2 hp__h2">Развивайте себя и свой бизнес</h2>
            {/* <a href="#" className="hp__anchor hp__develop-anchor link">
              Все сервисы
              <div className="hp__develop-icon">
                <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.72626 7.325L11.7739 4.175" stroke="#FF2D23" strokeLinecap="round"/>
                  <path d="M11.7737 3.825L8.72612 0.675" stroke="#FF2D23" strokeLinecap="round"/>
                  <path d="M11.9643 3.99999L0.75 3.99999" stroke="#FF2D23" strokeLinecap="round"/>
                </svg>
              </div>
            </a> */}
          </div>
          <div className="hp__develop-grid">
            {
              DevelopItems.map(item => (
                <a className="hp__develop-item" href={item.link} target={`_blank`} key={`about-${item.id}`}>
                  <div className="hp__develop-square">
                    <img className="hp__develop-pic" src={require(`../../assets/images/hp/develop/${item.id}.svg`).default} alt="" />
                    <img className="hp__develop-pic-revert" src={require(`../../assets/images/hp/develop-revert/${item.id}.svg`).default} alt="" />
                  </div>

                  <div className="hp__develop-content">
                    <h4 className="h5 hp__develop-h4">{item.title}</h4>
                    <p className="big-text-sm hp__develop-descr">{item.descr}</p>
                    <span className="hp__develop-item-anchor link">
                      Подробнее
                    </span>
                  </div>
                </a>
                ))
              }

            </div>

            {
              // isMobile && <a href="#" className="button hp__develop-all" target={`_blank`}>Все сервисы</a>
            }
          </section>

          <section className="hp__news hp__section-margin">
            <div className="hp__title">
              <h2 className="h2 hp__h2">Важные новости</h2>
              <p className="hp__descr big-text">Подпишитесь, чтобы быть в курсе</p>
            </div>

            <div className="hp__socials">
              <a className="hp__socials-item" href="https://t.me/pan_live" target={`_blank`}>
                <div className="hp__socials-img hp__socials-img_tg">
                  <svg width="45" height="38" viewBox="0 0 45 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_547_5444)">
                    <path d="M45.0002 1.34929L37.8882 36.4176C37.8882 36.4176 36.8923 38.8518 34.1533 37.6803L17.735 25.3722L11.7591 22.5576L1.70585 19.2562C1.70585 19.2562 0.165181 18.7237 0.00955802 17.5522C-0.146065 16.3807 1.75254 15.7569 1.75254 15.7569L41.7166 0.436454C41.7166 0.42124 45.0002 -0.993661 45.0002 1.34929Z" fill="white"/>
                    <path d="M16.4586 36.0222C16.4586 36.0222 15.9762 35.9765 15.3848 34.1356C14.7934 32.2948 11.7588 22.5578 11.7588 22.5578L35.8959 7.57201C35.8959 7.57201 37.2966 6.75046 37.2343 7.57201C37.2343 7.57201 37.4833 7.72416 36.7363 8.39357C35.9893 9.06299 17.7814 25.0833 17.7814 25.0833" fill="#D2E4F0"/>
                    <path d="M24.0218 30.0887L17.5324 35.8852C17.5324 35.8852 17.0188 36.2656 16.4741 36.0222L17.7191 25.2659" fill="#B5CFE4"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_547_5444">
                    <rect width="45" height="38" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>

                </div>
                <div className="hp__socials-content">
                  <h3 className="hp__socials-h3 h3">
                    ПАН — LIVE
                  </h3>
                  <p className="big-text-sm color-brand-3">Telegram-канал, который хочется читать</p>
                </div>
              </a>

              <a className="hp__socials-item" href="https://vk.com/panpartnerspb" target={`_blank`}>
                <div className="hp__socials-img hp__socials-img_vk">
                  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M32.2668 42.5531C33.5512 42.5531 33.5512 40.7521 33.5512 39.9802C33.5512 38.6938 34.8357 37.4073 36.1201 37.4073C37.4046 37.4073 39.5881 39.5943 41.2579 41.2667C42.5423 42.5531 42.5423 42.5531 43.8268 42.5531H47.6783C47.6783 42.5531 50.2472 42.4245 50.2472 39.9802C50.2472 39.2083 49.3499 37.7932 46.3957 34.8344C43.8268 32.2615 42.5423 33.5479 46.3957 28.4021C48.7077 25.1878 50.5059 22.3557 50.2472 21.5839C49.9903 20.8138 43.4415 19.5255 42.5423 20.6852C39.9734 24.5427 39.4597 25.4432 38.689 27.1156C37.4046 29.6904 37.2742 30.975 36.1201 30.975C34.9641 30.975 34.8357 28.5307 34.8357 27.1156C34.8357 22.8703 35.4779 19.9115 33.5512 19.3969H29.6979C27.6428 19.3969 25.8445 20.6852 25.8445 20.6852C25.8445 20.6852 24.305 21.9698 24.5601 21.9698C24.9454 21.9698 27.129 21.4571 27.129 23.2563V25.8292C27.129 25.8292 27.129 30.975 25.8445 30.975C24.5601 30.975 21.9912 25.8292 19.4241 21.9698C18.5232 20.4279 18.1378 20.6852 16.8553 20.6852H13.0001C11.7175 20.6852 11.589 21.5839 11.7175 21.9698C14.2864 28.4021 16.0846 32.3901 20.9655 37.5359C25.4592 42.1672 28.4134 42.4245 30.9842 42.5531H32.2668Z" fill="white"/>
                  </svg>
                </div>
                <div className="hp__socials-content">
                  <h3 className="hp__socials-h3 h3">
                    ВКонтакте
                  </h3>
                  <p className="big-text-sm color-brand-3">Подборка предложений, которые помогут заработать</p>
                </div>
              </a>

            </div>
          </section>

          <section className="hp__mobile hp__section-margin">
            <div className="hp__mobile-content">
              <h3 className="h3 hp__mobile-h3">Мобильный партнер</h3>
              <p className="big-text hp__mobile-text">Все возможности платформы в приложении для Android и iPhone</p>

              <div className="hp__mobile-apps">
                <a href="https://apple.co/3klTwLt" className="hp__mobile-app" target={`_blank`}>
                  <AppleIcon />
                </a>
                <a href="https://bit.ly/3kGH4q1" className="hp__mobile-app" target={`_blank`}>
                  <GoogleIcon />
                </a>
              </div>

            </div>
            <img className="hp__mobile-code" src={require(`../../assets/images/hp/code.svg`).default} alt="" />
          </section>

          <section className="hp__banner hp__banner_main">
            <div className="hp__banner-content">
              <h2 className="h2 hp__banner-h2">Получите доступ ко всем сервисам и готовым решениям</h2>
              <p className="big-text-sm hp__banner-text">для успешных сделок и развития вашего бизнеса</p>
            </div>

            <div className="hp__banner-nav">
              <Link to={`/register/new${utms}`} className="hp__banner-btn button button_view_default">Стать партнером</Link>
              <Link to={`/trial${utms}`} className="hp__banner-anchor link">Доступ без регистрации</Link>
            </div>
          </section>
        </div>
      </div>
    </>

  );
};

const DevelopItems = [
  {
    id: `01`,
    title: `ПАН Комфорт`,
    descr: `Проводите бизнес-встречи в удобной локации`,
    link: `https://panpartner.ru/pan-comfort/`,
  },
  {
    id: `02`,
    title: `ПАН Trade-In`,
    descr: `Для ваших легких сделок по Trade-in`,
    link: `https://panpartner.ru/trade-in`,
  },
  // {
  //   id: `03`,
  //   title: `АвтоПАН`,
  //   descr: `Закройте клиента на сделку прямо на объекте`,
  //   link: `https://panpartner.ru/autopan`,
  // },
  // {
  //   id: `04`,
  //   title: `ПАН Юрист`,
  //   descr: `Для безопасных, юридически чистых сделок`,
  //   link: `https://panpartner.ru/legal-services`,
  // },
  // {
  //   id: `05`,
  //   title: `Оценка недвижимости`,
  //   descr: `Возвращаем до 3000 ₽ бонусом`,
  //   link: `https://pan-ocenka.ru/`,
  // },
  // {
  //   id: `06`,
  //   title: `Ипотечное вознаграждение`,
  //   descr: `Получайте максимум от каждой сделки`,
  //   link: `https://panpartner.ru/cashback`,
  // },
  {
    id: `07`,
    title: `Конструктор сайтов`,
    descr: `Для быстрого развития вашего бренда`,
    link: `https://pan-promo.ru/`,
  },
  {
    id: `08`,
    title: `Расширенное бронирование`,
    descr: `Откройте для себя больше возможностей рынка`,
    link: `https://panpartner.ru/adv-booking`,
  },
];

const AboutItems = [
  {
    id: `01`,
    title: `Я риелтор`,
    descr: `Партнерские привилегии и бонусы с каждой сделки`,
    link: `/register/realtor`,
  },

  {
    id: `02`,
    title: `Я владелец агентства`,
    descr: `Повышайте продажи и эффективность сотрудников`,
    link: `/register/agency`,
  },

  {
    id: `03`,
    title: `Я начинающий агент`,
    descr: `Секреты успешной работы с клиентами и не только`,
    link: `/register/agent`,
  },

  // {
  //   id: `04`,
  //   title: `Я застройщик`,
  //   descr: `Эксклюзивные условия продажи ваших объектов`,
  //   link: `/selfemployed`,
  // },


  {
    id: `04`,
    title: `Я застройщик`,
    descr: `Повышайте продажи с нашей партнерской сетью`,
    link: `/register/developer`,
    isSelf: true,
  },

];

const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="203"
      height="57"
      fill="none"
      viewBox="0 0 203 57"
      className="hp__mobile-img"
    >
      <rect width="203" height="57" rx="5"></rect>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M72.282 33.14v2.587h6.208a5.418 5.418 0 01-1.437 3.263 6.352 6.352 0 01-4.786 1.897 6.898 6.898 0 010-13.797 6.61 6.61 0 014.7 1.854l1.825-1.825a9.04 9.04 0 00-6.51-2.688 9.5 9.5 0 100 18.985 8.623 8.623 0 006.625-2.658 8.623 8.623 0 002.242-6.065 8.433 8.433 0 00-.144-1.624l-8.723.072zm15.938-1.882a6.108 6.108 0 106.122 6.108 6.022 6.022 0 00-6.137-6.108h.015zm7.3 6.127a6.108 6.108 0 016.079-6.127 6.023 6.023 0 016.137 6.108 6.108 6.108 0 01-12.216.019zm2.475 1.588a3.708 3.708 0 003.605 2.1 3.533 3.533 0 003.449-3.707 3.708 3.708 0 10-7.054 1.607zm-13.39.011a3.708 3.708 0 003.615 2.09h-.015a3.535 3.535 0 003.45-3.708 3.708 3.708 0 10-7.05 1.618zm47.563-7.726a5.749 5.749 0 015.231 3.895l.302.646-8.178 3.378a3.105 3.105 0 002.961 1.854 3.493 3.493 0 003.004-1.696l2.083 1.437a6.078 6.078 0 01-5.087 2.702 5.979 5.979 0 01-6.065-6.108 5.75 5.75 0 015.749-6.108zm-3.105 5.935a3.354 3.354 0 013.191-3.564 2.372 2.372 0 012.271 1.294l-5.462 2.27zm-3.952 5.922h-2.687V25.15h2.687v17.965zm-7.085-10.492h-.1a4.314 4.314 0 00-3.22-1.437 6.122 6.122 0 000 12.23 4.17 4.17 0 003.22-1.437h.086v.877c0 2.342-1.251 3.593-3.263 3.593a3.377 3.377 0 01-3.075-2.17l-2.343.977a5.82 5.82 0 005.418 3.607c3.148 0 5.749-1.854 5.749-6.367V31.617h-2.472v1.006zm-3.08 8.45h.005-.015.01zm2.422-1.152a3.42 3.42 0 01-2.422 1.152 3.723 3.723 0 01.005-7.415 3.448 3.448 0 013.262 3.708 3.421 3.421 0 01-.845 2.555zm32.62-14.77h-6.424v17.963h2.688v-6.812h3.751a5.59 5.59 0 100-11.152h-.015zm-3.751 8.622h3.751l.058.043a3.083 3.083 0 000-6.165h-3.809v6.122zm20.322-2.587c-2-.12-3.88.959-4.786 2.745l2.386.992a2.542 2.542 0 012.443-1.323 2.586 2.586 0 012.874 2.314v.187a5.936 5.936 0 00-2.802-.69c-2.573 0-5.174 1.437-5.174 4.039a4.153 4.153 0 004.455 3.952 3.78 3.78 0 003.449-1.725h.087v1.437h2.586v-6.912c0-3.148-2.385-4.973-5.446-4.973l-.072-.043zm-2.429 8.321c0 1.078 1.222 1.524 2.098 1.524l.072.043a3.247 3.247 0 003.147-2.875 4.768 4.768 0 00-2.443-.603c-1.351 0-2.874.474-2.874 1.911zm17.375-7.89l-3.075 7.79h-.087l-3.19-7.79h-2.874l4.785 10.894-2.73 6.05h2.802l7.358-16.944h-2.989zm-21.471 11.497h-2.687V25.15h2.687v17.965z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#8F95AC"
        d="M63.132 12.85h4.521v5.644h-.711v-4.996h-3.099v4.996h-.711V12.85zm10.2 5.644l-.585-1.731h-2.474l-.585 1.73h-.727l1.952-5.643h1.202l1.96 5.644h-.743zm-1.984-4.917l-.861 2.538h2.039l-.862-2.538h-.316zm7.897-.727h.711v5.644h-.711v-2.577h-3.154v2.577h-.711V12.85h.711v2.403h3.154V12.85zm2.58 0h4.52v5.644h-.711v-4.996h-3.099v4.996h-.71V12.85zm10.2 5.644l-.586-1.731h-2.474l-.585 1.73h-.727l1.953-5.643h1.201l1.96 5.644h-.743zm-1.985-4.917l-.861 2.538h2.04l-.862-2.538h-.317zm4.032-.727h2.387c.611 0 1.083.148 1.415.443.332.295.498.709.498 1.24 0 .538-.166.957-.498 1.258-.332.295-.804.442-1.415.442h-1.675v2.26h-.712V12.85zm.712 2.75h1.557c.874 0 1.312-.352 1.312-1.058 0-.707-.438-1.06-1.312-1.06h-1.557v2.119zm8.995-2.75v.632h-1.849v5.012h-.712v-5.012h-1.865v-.632h4.426zm5.163 0h.712v5.644h-.712v-2.577h-3.153v2.577h-.712V12.85h.712v2.403h3.153V12.85zm3.291 4.996h3.343v.648h-4.054V12.85h3.928v.648h-3.217v1.747h2.593v.648h-2.593v1.953zm4.876-4.996h2.387c.611 0 1.083.148 1.415.443.332.295.498.709.498 1.24 0 .538-.166.957-.498 1.258-.332.295-.804.442-1.415.442h-1.676v2.26h-.711V12.85zm.711 2.75h1.558c.874 0 1.312-.352 1.312-1.058 0-.707-.438-1.06-1.312-1.06h-1.558v2.119zm12.022 2.246h.815v2.031h-.704v-1.383h-4.276v1.383h-.704v-2.031h.585c.475-1.002.712-2.287.712-3.858V12.85h3.572v4.996zm-.703 0v-4.348h-2.19v.609c0 1.539-.21 2.785-.632 3.739h2.822zm5.228-5.099c.827 0 1.472.277 1.936.83.464.554.696 1.252.696 2.095 0 .843-.232 1.541-.696 2.095-.464.553-1.109.83-1.936.83-.833 0-1.481-.274-1.945-.823-.458-.553-.688-1.254-.688-2.102 0-.849.23-1.547.688-2.095.464-.553 1.112-.83 1.945-.83zm-1.431 4.545c.321.438.798.656 1.431.656.632 0 1.109-.218 1.43-.656.322-.437.482-.977.482-1.62 0-.643-.16-1.183-.482-1.62-.321-.438-.798-.656-1.43-.656-.633 0-1.11.218-1.431.655-.322.438-.482.978-.482 1.62 0 .644.16 1.184.482 1.621zm9.461-.403h.751c-.122.522-.375.938-.759 1.25-.385.305-.878.457-1.478.457-.822 0-1.463-.27-1.921-.814-.459-.542-.688-1.246-.688-2.11 0-.864.232-1.568.696-2.11.463-.543 1.104-.815 1.921-.815.569 0 1.043.143 1.422.427.38.28.627.664.743 1.154h-.751c-.221-.622-.693-.932-1.414-.932-.622 0-1.094.218-1.415.655-.322.438-.483.978-.483 1.62 0 .65.159 1.192.475 1.63.321.431.793.647 1.415.647.39 0 .711-.092.964-.276.253-.19.427-.45.522-.783zm6.144-4.039v.632h-1.85v5.012h-.711v-5.012h-1.866v-.632h4.427zm3.053 2.964h.221l1.415-2.964h.743l-2.696 5.644h-.735l.807-1.692-2.087-3.952h.767l1.565 2.964zm3.709-2.964h4.521v5.644h-.711v-4.996h-3.099v4.996h-.711V12.85zm7.102 4.996h3.343v.648h-4.055V12.85h3.929v.648h-3.217v1.747h2.592v.648h-2.592v1.953zm8.741-4.996h.711v5.644h-.711v-2.577h-3.154v2.577h-.711V12.85h.711v2.403h3.154V12.85zM180 15.427v.174c.237.11.427.284.569.521.148.238.221.498.221.783 0 .474-.163.859-.49 1.154-.326.29-.801.435-1.422.435h-2.522V12.85h2.458c.575 0 1.017.137 1.328.411.316.269.474.609.474 1.02 0 .542-.205.925-.616 1.146zm-2.933-1.945v1.763h1.731c.733 0 1.099-.3 1.099-.901 0-.295-.105-.511-.316-.648-.211-.142-.477-.214-.798-.214h-1.716zm0 4.38h1.763c.364 0 .661-.077.893-.23.232-.158.348-.419.348-.782 0-.343-.116-.59-.348-.743-.226-.158-.521-.237-.885-.237h-1.771v1.991z"
      ></path>
      <path
        fill="url(#paint0_linear_635_5981)"
        d="M18.675 10.836a2.874 2.874 0 00-.66 2.012v31.79c-.044.73.192 1.45.66 2.012l.101.1 17.806-17.792v-.416L18.776 10.735l-.1.101z"
      ></path>
      <path
        fill="url(#paint1_linear_635_5981)"
        d="M42.475 34.894l-5.892-5.935v-.417l5.892-5.95.13.072 7.056 4.01c2.012 1.135 2.012 3.003 0 4.153l-7.028 3.995-.158.072z"
      ></path>
      <path
        fill="url(#paint2_linear_635_5981)"
        d="M42.647 34.808l-6.065-6.065L18.675 46.65c.846.744 2.102.78 2.99.086L42.66 34.808"
      ></path>
      <path
        fill="url(#paint3_linear_635_5981)"
        d="M42.647 22.678L21.65 10.75a2.342 2.342 0 00-2.989.086l17.921 17.907 6.065-6.065z"
      ></path>
      <path
        fill="#000"
        d="M42.474 34.678L21.65 46.535a2.4 2.4 0 01-2.874 0l-.1.1.1.101c.85.642 2.024.642 2.874 0l20.997-11.928-.172-.13z"
        opacity="0.2"
      ></path>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M42.475 34.678l7.185-4.067a2.673 2.673 0 001.438-1.868 2.515 2.515 0 01-1.438 2.07l-7.056 3.995-.13-.13zM18.01 44.716c.024.633.256 1.242.665 1.733l.1.115-.1.1a2.874 2.874 0 01-.665-1.948zm0 0l.003-.064v-.215a2.872 2.872 0 00-.003.28z"
        clipRule="evenodd"
        opacity="0.12"
      ></path>
      <path
        fill="#fff"
        d="M21.65 10.951l28.01 15.924a2.673 2.673 0 011.438 1.868 2.515 2.515 0 00-1.438-2.07L21.65 10.75C19.638 9.614 18 10.563 18 12.862v.216c.043-2.314 1.653-3.262 3.65-2.127z"
        opacity="0.25"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_635_5981"
          x1="28.783"
          x2="0.271"
          y1="-10.864"
          y2="-3.281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF"></stop>
          <stop offset="0.01" stopColor="#00A1FF"></stop>
          <stop offset="0.26" stopColor="#00BEFF"></stop>
          <stop offset="0.51" stopColor="#00D2FF"></stop>
          <stop offset="0.76" stopColor="#00DFFF"></stop>
          <stop offset="1" stopColor="#00E3FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_635_5981"
          x1="52.291"
          x2="17.526"
          y1="14.084"
          y2="14.084"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000"></stop>
          <stop offset="0.41" stopColor="#FFBD00"></stop>
          <stop offset="0.78" stopColor="orange"></stop>
          <stop offset="1" stopColor="#FF9C00"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_635_5981"
          x1="18.149"
          x2="-4.754"
          y1="19.441"
          y2="57.966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44"></stop>
          <stop offset="1" stopColor="#C31162"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_635_5981"
          x1="4.692"
          x2="14.915"
          y1="5.887"
          y2="23.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071"></stop>
          <stop offset="0.07" stopColor="#2DA771"></stop>
          <stop offset="0.48" stopColor="#15CF74"></stop>
          <stop offset="0.8" stopColor="#06E775"></stop>
          <stop offset="1" stopColor="#00F076"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

const AppleIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="183"
    height="57"
    fill="none"
    viewBox="0 0 183 57"
    className="hp__mobile-img"
  >
    <rect width="183" height="57" rx="5.57"></rect>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M111.514 41.787c-2.349 0-4.069-1.162-4.267-2.932h-2.734c.173 3.228 2.845 5.27 6.803 5.27 4.23 0 6.888-2.091 6.888-5.43 0-2.61-1.52-4.081-5.181-4.947l-1.967-.483c-2.3-.568-3.24-1.31-3.24-2.573 0-1.583 1.472-2.67 3.624-2.67 2.151 0 3.623 1.075 3.785 2.856h2.696c-.087-3.08-2.672-5.195-6.445-5.195-3.809 0-6.492 2.116-6.492 5.195 0 2.487 1.521 4.02 4.798 4.81l2.313.558c2.313.568 3.29 1.398 3.29 2.783 0 1.596-1.62 2.758-3.871 2.758zm-46.53-2.783h-6.802l-1.634 4.824h-2.882L60.11 25.98h2.993l6.444 17.846h-2.93l-1.633-4.823zm-6.098-2.226h5.392L61.62 28.95h-.074l-2.66 7.828zm19.146 7.186c3.266 0 5.43-2.598 5.43-6.642 0-4.032-2.177-6.642-5.479-6.642a4.616 4.616 0 00-4.143 2.3h-.05v-2.164h-2.584v17.316h2.67v-6.445h.062a4.411 4.411 0 004.094 2.277zm2.685-6.642c0-2.634-1.361-4.366-3.439-4.366-2.04 0-3.413 1.769-3.413 4.366 0 2.622 1.373 4.378 3.413 4.378 2.078 0 3.439-1.72 3.439-4.378zm11.636 6.642c3.266 0 5.43-2.598 5.43-6.642 0-4.032-2.177-6.642-5.48-6.642a4.616 4.616 0 00-4.142 2.3h-.05v-2.164h-2.584v17.316h2.67v-6.445h.062a4.411 4.411 0 004.094 2.277zm2.685-6.642c0-2.634-1.361-4.366-3.439-4.366-2.04 0-3.413 1.769-3.413 4.366 0 2.622 1.373 4.378 3.413 4.378 2.078 0 3.439-1.72 3.439-4.378zm28.933-9.585v3.08h2.474v2.114h-2.474v7.173c0 1.115.496 1.634 1.583 1.634.294-.005.587-.026.879-.062v2.102a7.345 7.345 0 01-1.484.124c-2.634 0-3.661-.99-3.661-3.513v-7.458h-1.892v-2.115h1.892v-3.08h2.683zm10.077 2.919c-3.76 0-6.171 2.573-6.171 6.666 0 4.106 2.387 6.667 6.171 6.667 3.785 0 6.173-2.561 6.173-6.666 0-4.095-2.4-6.667-6.173-6.667zm3.451 6.667c0-2.809-1.287-4.466-3.451-4.466s-3.451 1.67-3.451 4.466c0 2.82 1.287 4.464 3.451 4.464s3.451-1.645 3.451-4.464zm7.471-6.507h-2.547v13.012h2.67V36.11a2.691 2.691 0 012.783-2.994 3.73 3.73 0 011.2.162V30.78c-.3-.068-.607-.101-.915-.1a3.103 3.103 0 00-3.129 2.35h-.062v-2.214zm16.42 9.19c-.359 2.362-2.659 3.983-5.602 3.983-3.785 0-6.135-2.536-6.135-6.605 0-4.081 2.362-6.728 6.023-6.728 3.599 0 5.863 2.473 5.863 6.418v.915h-9.19v.162a3.391 3.391 0 003.501 3.685 2.942 2.942 0 003.004-1.83h2.536zm-2.523-3.883h-6.505a3.292 3.292 0 013.314-3.303 3.13 3.13 0 013.191 3.303z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#8F95AC"
      d="M54.386 12.85h4.521v5.644h-.711v-4.996h-3.099v4.996h-.711V12.85zm9.769 5.644l-.585-1.731h-2.474l-.585 1.73h-.727l1.952-5.643h1.202l1.96 5.644h-.743zm-1.984-4.917l-.862 2.538h2.04l-.862-2.538h-.316zm7.466-.727h.711v5.644h-.711v-2.577h-3.154v2.577h-.712V12.85h.712v2.403h3.154V12.85zm2.148 0h4.52v5.644h-.71v-4.996h-3.099v4.996h-.711V12.85zm9.769 5.644l-.585-1.731h-2.474l-.585 1.73h-.727l1.952-5.643h1.201l1.96 5.644h-.742zm-1.984-4.917l-.862 2.538h2.04l-.862-2.538h-.316zm3.6-.727h2.387c.612 0 1.083.148 1.415.443.332.295.498.709.498 1.24 0 .538-.166.957-.498 1.258-.332.295-.803.442-1.415.442h-1.675v2.26h-.712V12.85zm.712 2.75h1.557c.875 0 1.312-.352 1.312-1.058 0-.707-.438-1.06-1.312-1.06h-1.557v2.119zm8.564-2.75v.632h-1.85v5.012h-.71v-5.012H88.02v-.632h4.426zm4.732 0h.712v5.644h-.712v-2.577h-3.153v2.577h-.712V12.85h.712v2.403h3.153V12.85zm2.86 4.996h3.343v.648h-4.055V12.85h3.929v.648h-3.217v1.747h2.592v.648h-2.592v1.953zm4.445-4.996h2.387c.611 0 1.083.148 1.415.443.332.295.498.709.498 1.24 0 .538-.166.957-.498 1.258-.332.295-.804.442-1.415.442h-1.676v2.26h-.711V12.85zm.711 2.75h1.557c.875 0 1.312-.352 1.312-1.058 0-.707-.437-1.06-1.312-1.06h-1.557v2.119zm11.16 2.246h.814v2.031h-.704v-1.383h-4.276v1.383h-.703v-2.031h.585c.474-1.002.711-2.287.711-3.858V12.85h3.573v4.996zm-.704 0v-4.348h-2.189v.609c0 1.539-.211 2.785-.633 3.739h2.822zm4.797-5.099c.827 0 1.473.277 1.936.83.464.554.696 1.252.696 2.095 0 .843-.232 1.541-.696 2.095-.463.553-1.109.83-1.936.83-.833 0-1.481-.274-1.945-.823-.458-.553-.687-1.254-.687-2.102 0-.849.229-1.547.687-2.095.464-.553 1.112-.83 1.945-.83zm-1.431 4.545c.321.438.798.656 1.431.656.632 0 1.109-.218 1.43-.656.322-.437.483-.977.483-1.62 0-.643-.161-1.183-.483-1.62-.321-.438-.798-.656-1.43-.656-.633 0-1.11.218-1.431.655-.321.438-.482.978-.482 1.62 0 .644.161 1.184.482 1.621zm9.03-.403h.751c-.122.522-.375.938-.759 1.25-.385.305-.878.457-1.478.457-.822 0-1.463-.27-1.921-.814-.459-.542-.688-1.246-.688-2.11 0-.864.232-1.568.696-2.11.463-.543 1.104-.815 1.921-.815.569 0 1.043.143 1.422.427.38.28.627.664.743 1.154h-.751c-.221-.622-.693-.932-1.414-.932-.622 0-1.094.218-1.415.655-.322.438-.483.978-.483 1.62 0 .65.159 1.192.475 1.63.321.431.793.647 1.415.647.39 0 .711-.092.964-.276.253-.19.427-.45.522-.783zm5.713-4.039v.632h-1.85v5.012h-.711v-5.012h-1.866v-.632h4.427zm2.621 2.964h.222l1.415-2.964h.743l-2.696 5.644h-.735l.806-1.692-2.086-3.952h.766l1.565 2.964zm3.278-2.964h4.522v5.644h-.712v-4.996h-3.098v4.996h-.712V12.85zm6.671 4.996h3.344v.648h-4.055V12.85h3.928v.648h-3.217v1.747h2.593v.648h-2.593v1.953zm8.31-4.996h.712v5.644h-.712v-2.577h-3.154v2.577h-.711V12.85h.711v2.403h3.154V12.85zm7.992 2.577v.174c.237.11.427.284.569.521.148.238.221.498.221.783 0 .474-.163.859-.49 1.154-.326.29-.801.435-1.422.435h-2.522V12.85h2.458c.575 0 1.017.137 1.328.411.316.269.474.609.474 1.02 0 .542-.205.925-.616 1.146zm-2.933-1.945v1.763h1.731c.733 0 1.099-.3 1.099-.901 0-.295-.105-.511-.316-.648-.211-.142-.477-.214-.798-.214h-1.716zm0 4.38h1.763c.364 0 .661-.077.893-.23.232-.158.348-.419.348-.782 0-.343-.116-.59-.348-.743-.226-.158-.521-.237-.885-.237h-1.771v1.991z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M37.698 11.277a7.281 7.281 0 01-1.666 5.217 6.126 6.126 0 01-4.837 2.287 6.929 6.929 0 011.709-5.023 7.41 7.41 0 014.794-2.48zm5.938 11.102a7.396 7.396 0 00-3.522 6.205 7.147 7.147 0 004.363 6.575 16.383 16.383 0 01-2.27 4.621c-1.336 2-2.737 3.953-4.962 3.99-1.057.024-1.772-.28-2.516-.598-.776-.33-1.585-.675-2.85-.675-1.343 0-2.188.356-3.003.699-.704.296-1.386.583-2.347.623-2.118.079-3.737-2.134-5.122-4.115-2.769-4.045-4.925-11.4-2.035-16.403a7.944 7.944 0 016.685-4.077c1.202-.025 2.355.438 3.365.844.773.31 1.463.588 2.028.588.497 0 1.167-.266 1.949-.576 1.231-.489 2.737-1.087 4.273-.926a7.571 7.571 0 015.964 3.225z"
      clipRule="evenodd"
    ></path>
  </svg>
  )
};

export const ActionIcon = () => {
  return (
    <svg width="74" height="50" viewBox="0 0 74 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M43.4932 42.8142C60.2652 32.4167 68.3219 15.124 61.4883 4.18976C54.6547 -6.74445 35.5187 -7.17957 18.7467 3.21786C1.97476 13.6153 -6.08189 30.908 0.751675 41.8422C7.58524 52.7764 26.7213 53.2116 43.4932 42.8142Z" fill="#DFE1E9"/>
      <path d="M27.9447 51.8362C27.9447 51.8362 13.0848 56.3021 2.73782 49.9521C-7.60922 43.6021 -13.8694 32.3332 -12.9019 30.4779C-11.9343 28.6225 4.60433 25.5086 12.5794 31.5566C20.5545 37.6045 27.9447 51.8362 27.9447 51.8362Z" fill="#519B48"/>
      <path d="M-8.88721 28.8239C-3.4718 33.2286 11.3772 44.6449 27.9375 51.8363C27.9375 51.8363 20.5473 37.6154 12.5723 31.5638C6.86081 27.2095 -3.2588 27.5906 -8.88721 28.8239Z" fill="url(#paint0_linear_1920_15148)"/>
      <path d="M41.5019 -9.76763C39.928 -7.47999 34.1757 1.53933 29.422 17.4494C24.5845 33.6261 31.647 44.1055 33.5765 46.5602C34.1117 30.3319 42.3647 -9.87107 42.3647 -9.87107C42.2361 -9.97013 42.0735 -10.0148 41.912 -9.99546C41.7506 -9.9761 41.6033 -9.89427 41.5019 -9.76763Z" fill="#519B48"/>
      <path d="M42.381 -9.87109C42.381 -9.87109 34.1121 30.3318 33.5928 46.5602C33.8844 46.9302 34.0602 47.1212 34.0602 47.1212C63.5687 23.5962 45.8364 -5.69365 42.381 -9.87109Z" fill="url(#paint1_linear_1920_15148)"/>
      <path d="M28.329 52.7056C28.329 52.7056 29.6917 54.4154 32.337 53.7335C34.1072 53.2811 36.011 52.7788 36.011 52.7788C36.011 52.7788 38.2989 52.1435 36.9161 49.6652C35.6135 47.3367 29.4879 35.99 29.4879 35.99L25.5067 36.5389L24.4546 41.3623L28.329 52.7056Z" fill="#B5BBC7"/>
      <path d="M18.0547 39.8987L18.9498 42.7861C18.9498 42.7861 19.4241 45.2676 22.7006 44.4493L28.0279 52.3996C28.0279 52.3996 28.6959 53.4209 30.4861 53.0649C32.2764 52.709 34.1601 52.1102 34.1601 52.1102C34.1601 52.1102 36.0974 51.6811 34.8515 49.7118C33.422 47.4498 28.0112 37.1809 28.0112 37.1809L18.0547 39.8987Z" fill="#F2F2F9"/>
      <path d="M10.4128 33.4984C13.3642 33.4984 15.7568 31.1155 15.7568 28.176C15.7568 25.2366 13.3642 22.8536 10.4128 22.8536C7.46143 22.8536 5.06885 25.2366 5.06885 28.176C5.06885 31.1155 7.46143 33.4984 10.4128 33.4984Z" fill="#8F95AC"/>
      <path d="M27.2855 31.3577L16.6047 34.2758C15.6316 34.5417 15.0592 35.5428 15.3261 36.512L16.0586 39.1714C16.3255 40.1405 17.3308 40.7106 18.3038 40.4448L28.9846 37.5267C29.9577 37.2608 30.5302 36.2597 30.2632 35.2905L29.5307 32.6311C29.2638 31.662 28.2586 31.0919 27.2855 31.3577Z" fill="#B5BBC7"/>
      <path d="M30.2426 35.2648C30.2426 35.2648 29.6046 34.9521 26.4951 35.6341C23.3856 36.316 15.8439 38.4316 15.8439 38.4316L14.2173 32.5205L28.419 28.6384L30.2426 35.2648Z" fill="#8F95AC"/>
      <path d="M44.8618 1.59741C44.8618 1.59741 33.6661 12.5948 19.6081 15.6585L12.2868 17.3218C12.2868 17.3218 7.74439 18.3596 8.61279 23.0999L10.884 32.8C10.884 32.8 12.1298 37.2475 16.0844 36.4591C20.0389 35.6707 27.9447 32.8865 35.2693 32.6669C42.5939 32.4474 52.4502 35.072 52.4502 35.072L44.8618 1.59741Z" fill="#F2F2F9"/>
      <path d="M52.46 35.0553L51.4146 30.4514L51.989 34.9355L52.46 35.0553Z" fill="#B4B9C5"/>
      <path d="M51.9894 34.9356L51.4149 30.4515L44.8618 1.59741C40.1633 5.95456 34.8345 9.58432 29.0536 12.3653C29.0536 12.3653 28.7931 23.6255 33.2453 32.7634C33.9267 32.7035 34.6047 32.6636 35.2794 32.6436C41.6521 32.4607 49.9453 34.4233 51.9894 34.9356Z" fill="#B5BBC7"/>
      <path d="M58.639 16.1109C61.4178 27.91 59.641 35.0087 55.6764 35.9135C51.7118 36.8183 46.6384 29.4235 44.3204 19.3908C42.0024 9.35807 43.3184 0.492958 47.283 -0.41185C51.2475 -1.31666 55.6196 3.28057 58.639 16.1109Z" fill="white"/>
      <path d="M56.3219 33.9844C59.0543 33.3582 59.5482 25.402 57.4251 16.2138C55.302 7.02554 51.3659 0.0847224 48.6335 0.710999C45.9011 1.33728 45.4071 9.29349 47.5302 18.4817C49.6533 27.6699 53.5895 34.6107 56.3219 33.9844Z" fill="#2C2E3E"/>
      <path d="M53.7535 25.5398C55.0316 25.2468 55.2632 21.5275 54.2707 17.2323C53.2783 12.9372 51.4376 9.69286 50.1595 9.9858C48.8813 10.2788 48.6498 13.9981 49.6422 18.2932C50.6347 22.5883 52.4753 25.8327 53.7535 25.5398Z" fill="#F2F2F9"/>
      <defs>
        <linearGradient id="paint0_linear_1920_15148" x1="-41.24" y1="27.4529" x2="-40.5587" y2="45.9718" gradientUnits="userSpaceOnUse">
          <stop stop-color="#519B48"/>
          <stop offset="0.67" stop-color="#006938"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1920_15148" x1="18.4619" y1="-11.1793" x2="26.5156" y2="31.6445" gradientUnits="userSpaceOnUse">
          <stop stop-color="#519B48"/>
          <stop offset="0.67" stop-color="#006938"/>
        </linearGradient>
      </defs>
    </svg>

  )
}

export default HomePage;
